import SEOHead from "@/components/General/SEOHead";
import Contact from "@/modules/Contact/Contact";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const ContactPage = () => {
  return (
    <>
      <SEOHead />
      <Contact />
    </>
  );
};

export async function getServerSideProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
export default ContactPage;
